import React from 'react'
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Tdssections from './Tds/Tdssections';
import Tdstax from './Tds/Tdstax';

function Tds() {
  return (
    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
      <Row>
        <Col sm={3}>
          <Nav variant="pills" className="flex-column">
            <Nav.Item>
              <Nav.Link eventKey="first">TDS Tax</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="second">TDS Sections</Nav.Link>
            </Nav.Item>
          </Nav>
        </Col>
        <Col sm={9} >
          <Tab.Content style={{backgroundColor:'#E6E6E6',padding:20,borderRadius:10}}>
            <Tab.Pane eventKey="first"><Tdstax/></Tab.Pane>
            <Tab.Pane eventKey="second"><Tdssections/></Tab.Pane>
          </Tab.Content>
        </Col>
      </Row>
    </Tab.Container>
  )
}

export default Tds